{
  "021e9a362a4994f4": "Dado que este profesional recientemente presentó una Solicitud de Tanda Perdida, esta solicitud expirará el {{formattedExpiryDate}}.",
  "028ff6788c05afa8": "Editar tiempo de descanso",
  "02a373602df5e9c7": "Descanso omitido",
  "02a63a5edd1acb79": "Nuevo total",
  "0427ec78ba6e5aa9": "Por favor, confirme que este profesional fue una no presentación.",
  "05641494de57fcc2": "Salió del lugar de trabajo",
  "08251562b3407a16": "Firmado",
  "09adde92f00886ef": "Registrar entrada",
  "0bfb51f390b55eb6": "Editar hora de salida",
  "0c68f8811f1b4745": "Rechazar solicitud de pago por descanso",
  "0c843ea50d04fd8d": "mins",
  "0e45302a9b0a1380": "Sí, me gustaría que Clipboard publicara un",
  "12698ce1ea5cd4ab": "Saltado",
  "1610dcd8f5e4eb1d": "Error al descargar hojas de tiempo",
  "183f9af034b83430": "p. ej. Atención aguda",
  "19766ed6ccb2f4a3": "Cancelar",
  "215020d85a22dd6d": "Desglose de cargos",
  "219a8125870cbae2": "Asignación de servicios de enfermería",
  "23f8b3f3130644fa": "Antes de marcar No Show, queremos señalar que el trabajador parece estar acercándose a su lugar de trabajo.",
  "2682d64f56d4520e": "Por favor, agregue notas para describir el evento de No Show con más detalle.",
  "29b9c49ceced7a4f": "Error al rechazar la solicitud de registro de entrada perdida",
  "2eb26f243ef314c9": "Solicitud de registro de entrada perdida aprobada",
  "31a43e88b660bc5f": "Corregir y aprobar",
  "32d57593e0a75d98": "Por favor, revise el tiempo de descanso antes de aprobar. Puede corregir los tiempos utilizando la opción 'Corregir y aprobar'.",
  "336aa39ab810e1ba": "Proporcione cualquier detalle o evidencia relevante. Ejemplo: \"al revisar las grabaciones de nuestras cámaras de seguridad y nuestros registros, está claro que tomó al menos un descanso completo.\"",
  "367a920a4538766d": "Se deducirá una tarifa de asignación de póliza 1099 del pago del trabajador.",
  "378f90f28922eec0": ". Note que no se le cobrará ninguna tarifa adicional, solo la tarifa estándar del turno.",
  "39c825bb1fb21d75": "Solicitud de registro de entrada perdida denegada",
  "3a3a98ffcc9fbd48": "Dado que es poco común que este profesional presente Solicitudes de Tanda Perdida, esta solicitud se aprobará automáticamente el {{formattedExpiryDate}}.",
  "3a8931a9b2f6bf69": "Disputa",
  "3eafb1d3e170874c": "Este es el descanso que se aprobará para este turno.",
  "3fba5ca0ea213e15": "Error al cargar la firma",
  "427d09f7274f2b9c": "Inicio del descanso",
  "45733af728fba90d": "Registrar salida",
  "45b63ffd01af7b9c": "Tarifa",
  "474e899ce7de15bb": "Estos son los tiempos que se aprobarán para este turno.",
  "4ba2e28476a135a9": "Rechazar y mantener el tiempo original",
  "4dc118081ffe8038": "¿Le gustaría que Clipboard buscara un reemplazo para este turno?",
  "4e58cd5500f23d06": "Proporcione cualquier detalle o evidencia relevante para aprobar esta solicitud.",
  "4e9682fa850ed767": "hrs",
  "4fc52a3c4c558b51": "Duración",
  "51f015a9ef778940": "Ver desglose de tarifas",
  "525c9d4fc3aaa4bc": "Salida aprobada",
  "5635fd1470060191": "Distancia:",
  "582d5b22c05c968b": "Perfil del trabajador",
  "5d70db404f538fe6": "Última actualización: {{lastUpdatedText}}",
  "5f4ca2b9dc0be27a": "Hubo un error al cargar los datos de la solicitud de descanso. Por favor, inténtelo de nuevo.",
  "6007acbe30b2cd98": "Aprobar",
  "61374592cd46e0e5": "Seguimiento en vivo",
  "61b026bea0a35469": "Total solicitado",
  "6c549ee1e989f842": "Error al aprobar la solicitud de registro de entrada perdida",
  "753ed53df5d6e46a": "Firmar y Aprobar",
  "76900f1bfd16c8d4": "Regresar",
  "77bbaafb4cd49df5": "Turno Verificado",
  "79b37076beca8703": "Videos de cumplimiento",
  "79c2657890c42470": "Ver disputa",
  "7c4812fdf490b279": "Antes de marcar No Show, queremos señalar que el trabajador parece estar a menos de una milla de su lugar de trabajo.",
  "7d9eb7acb13e2462": "Cerrar",
  "7e18daf2589c64cf": "A o antes de",
  "805dcf0e47b9268a": "Error al cargar el video.",
  "829ba374dbf79ec2": "Llegó al lugar de trabajo",
  "83b12c2216efb4fd": "Limpiar",
  "84a350e29c34791c": "No tiene permiso para revisar la solicitud",
  "861420e5f6afa58d": "Sí, y estoy de acuerdo con que este trabajador se vaya temprano.",
  "8794e1c96bc12483": "Entrada perdida",
  "8866ebaf72d9db46": "Descanso aprobado",
  "88d13fb561f5f0ae": "Registro de entrada solicitado",
  "892359d2dbcea6df": "No tiene permisos para aprobar/rechazar solicitudes de tiempo extra trabajado",
  "896ed1586c784540": "Video de entrada",
  "8d1e257246c30f33": "¿Rechazar la solicitud de registro de entrada perdida?",
  "8e409e7990b1dec4": "Colapsar detalles de expiración",
  "8f227bc8dd1f19c3": "Hora de entrada",
  "901ded342e740048": "Proporcione cualquier detalle o evidencia relevante.",
  "9527010f2660676a": "{{distanceInMiles}} millas",
  "974fc8fbbcda6c55": "p. ej. 2º piso",
  "9767bb53ab3b0419": "Este es el tiempo que será aprobado para este turno.",
  "989c2818e8546505": "¿Se fue el trabajador con tu permiso?",
  "9b03a3e87f69497d": "Salida perdida",
  "9c9c3275d4f0b964": "Ver solicitud",
  "9dcff98e275f0cb9": "Línea de tiempo",
  "9df3293f4edcce3a": "Entrada aprobada",
  "9ed200aeb78c5b9b": " aprobar solicitud",
  "a0e33d55f61f537c": "Esta solicitud incluye un descanso de {{actualMinutes}} minutos, pero la política de su lugar de trabajo requiere un descanso de {{requiredMinutes}} minutos.",
  "a17a99d060752978": "No se pueden cargar los detalles de la tarifa de carga",
  "a2d285b352873457": "Declinar",
  "a30973149663f8e2": "Esta solicitud no incluye un descanso, pero la política de su lugar de trabajo requiere un descanso de {{requiredMinutes}} minutos.",
  "a56346531cb85449": "Descanso solicitado",
  "a5da3ca559b94b1c": "No, este trabajador se fue sin permiso.",
  "a66279e9d80fdce2": "¿No estás de acuerdo con el tiempo? Aprueba uno corregido.",
  "abc9cac5db1dbf64": "Confirmo que este profesional fue un No Show.",
  "b141deb247a324d0": "Salida solicitada",
  "b25ab4ef060a24e6": "No se pudo cargar la información del turno. Por favor, intenta nuevamente más tarde.",
  "b37c7879f6c359f6": "No registrado",
  "b6e84006a2d887fb": "Solicitud de pago por descanso",
  "b74a51297835aaf2": "Solicitud de registro de entrada perdida",
  "b972e0dace316cb7": "La política de su lugar de trabajo requiere un descanso de {{requiredMinutes}} minutos.",
  "bc79cdffbaa8df09": "Más opciones",
  "bcbee36c4b46574b": "Rechazar turno completo",
  "bd15ec9cca8c0f3a": "Error al subir la firma",
  "bfbcdf460d925a2a": "¿Por qué está dejando el turno el trabajador antes de tiempo?",
  "c12f42ab6906563c": "Confirmar tiempos",
  "c192516734d09478": "Se deducirá una tarifa de asignación de póliza 1099 de {{fee}} del pago del trabajador.",
  "c19521a120ed2547": "{{etaMinutes}} minutos",
  "c5b309b1e9c2d334": "Ya estamos buscando un trabajador de reemplazo para este turno. Si aún deseas cancelar el turno, podrás hacerlo después de este paso.",
  "c731384aad60d2cc": "Nuevas horas",
  "c945ef2b1e798905": "Horas solicitadas",
  "c9b3c38247f744e1": "Total",
  "cba219dacebb145c": "turno urgente",
  "ccde26902b9baa9d": "Horas pagadas",
  "cd7a2f68b7d6acf7": "No, no necesito un trabajador de reemplazo para este turno.",
  "d520eeb5335e09be": "Su Profesional",
  "d5dc4dc63d4be8b5": "Anulado por {{overriddenByName}}",
  "d61f429ffad6746a": "Solicitud de descanso",
  "d8b80fa1b071170a": "Ver horas facturables",
  "d8c4a2cd2bfcee03": "Video de cumplimiento de reloj",
  "dac73427e17591e5": "Expandir detalles de expiración",
  "dcea8abbdff03524": "Revisar solicitud",
  "de9967524f056889": "Expira en",
  "e005cecbc48072c2": "Hora de salida",
  "e060705826724633": "Esta información será registrada para fines de auditoría y puede ser mostrada al lugar de trabajo y al trabajador.",
  "e2f79e5b60330bba": "N/A",
  "e5752d7cd0661ffa": "ETA:",
  "e6bfe21185e3f9a3": "Por favor describe la situación",
  "e7031d9ebf8f138f": "Aprobar automáticamente en",
  "eaac9a61b76662c5": "Video de salida",
  "ef0ed3ac55b074c5": "Parece que hemos perdido la conexión.",
  "ef80bb8ce97b8d1d": "Error al imprimir hojas de tiempo",
  "f005825b1b5a7719": "{{startTime}} – {{endTime}} ({{durationMinutes}} minutos)",
  "f1a73e2204a11407": "Firma",
  "f246a247c38be344": "Aprobar solicitud de entrada omitida",
  "f412428aae20acc4": "A las o después de",
  "f5c12a23ee6fa88d": "Por favor, explica por qué estás aprobando esta solicitud de falta de registro en nombre del lugar de trabajo.",
  "f71081fb0af48ae6": "Descanso",
  "f81ab834de5f8491": "Razón",
  "f8761a6adc77d9d0": "Esta información se compartirá con el profesional.",
  "feb7906e6f52183e": "Estación/Ala/Unidad/Piso",
  "ff967bedfdeba1aa": "Editar la hora de entrada"
}
